import { ContentBox } from 'components';

export default ContentBox({
  name: 'OrderCart',
  contentKey: 'orderCart',
});
